import React from 'react';
import { KEY_METRICS } from '../constants';
import StatsChart from './StatsChart';
import { ExternalLink, Check } from 'lucide-react';

const TrackRecord: React.FC = () => {
  return (
    <section id="track-record" className="py-24 bg-slate-950 scroll-mt-28">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-8 border-b border-slate-900 pb-8">
          <div className="max-w-xl">
            <h2 className="text-3xl font-light text-white mb-4">Track Record Auditado</h2>
            <p className="text-slate-500 font-light text-sm leading-relaxed">
              Transparencia total. Todas las operaciones son verificadas por terceros para garantizar la integridad matemática de los resultados.
            </p>
          </div>
          <a 
            href="https://app.bet-analytix.com/bankroll/1716950" 
            target="_blank" 
            rel="noopener noreferrer"
            className="group flex items-center gap-3 text-slate-400 hover:text-sage-400 text-sm font-mono tracking-widest uppercase transition-colors"
          >
            VER PREMIUM DE ENERO <ExternalLink size={14} className="group-hover:-translate-y-1 transition-transform" />
          </a>
        </div>

        {/* Metrics Grid - Architectural Layout */}
        <div className="grid grid-cols-2 md:grid-cols-4 border-t border-l border-slate-900 mb-16">
          {KEY_METRICS.map((metric, idx) => (
            <div key={idx} className="bg-slate-950 p-8 border-r border-b border-slate-900 hover:bg-slate-900/30 transition-colors">
              <p className="text-slate-500 text-xs font-mono uppercase tracking-widest mb-3">{metric.label}</p>
              <div className="flex items-baseline gap-2">
                <h3 className={`text-3xl md:text-4xl font-light ${metric.trend === 'up' ? 'text-white' : 'text-slate-300'}`}>
                  {metric.value}
                </h3>
              </div>
              <div className="mt-4 flex items-center gap-2">
                 <div className="bg-sage-400/10 text-sage-400 p-1">
                    <Check size={10} strokeWidth={3} />
                 </div>
                 <p className="text-[10px] text-slate-500 uppercase tracking-wide">
                     {metric.subtext}
                 </p>
              </div>
            </div>
          ))}
        </div>

        {/* Chart */}
        <StatsChart />
      </div>
    </section>
  );
};

export default TrackRecord;